import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';

export const TimeText = ({ children, ...props }: TextProps) => (
  <Text color="whiteAlpha.700" fontWeight="medium" size="detail" {...props}>
    {children}
  </Text>
);
